// year = 0
// month = 1
// day = 2
// hour = 3

export const generateDate = (timestamp, selected) => {
    const date = new Date(timestamp)
    let resStart, resEnd;
    if (selected === 0) {
        resStart = new Date(date.getFullYear(), date.getMonth(), 1)
        resEnd = new Date(date.getFullYear(), date.getMonth(), 31, 23, 59, 59)
    }
    else if (selected === 1) {
        resStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0)
        resEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
    }
    else if (selected === 2) {
        resStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0)
        resEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 59, 59)
    }
    return [+resStart, +resEnd]
}

const getTimestamp = (endTime, ammount, periodType = null) => {
    const values = {
        min: 1000 * 60,
        hou: 1000 * 60 * 60,
        day: 1000 * 60 * 60 * 24,
    }
    const date = new Date(endTime)
    let result
    if (periodType === 'yea') {
        const resultYear = date.getFullYear() - ammount
        result = date.setFullYear(resultYear)
    } else if (periodType === 'mon') {
        var tmp = new Date(endTime);
        result = tmp.setMonth(date.getMonth() - ammount)
    } else result = endTime - (values[periodType] * ammount)
    return result
}

// year = 0
// half year = 1
// month = 2
// week = 3
// day = 4

export const getCalendarDate = (interval) => {
    let resStart, resEnd
    const date = new Date()
    if (interval === 0) {
        resStart = new Date(date.getFullYear(), 0, 1)
        resEnd = new Date(date.getFullYear(), 12, 31, 23, 59, 59)
    } else if (interval === 1) {
        resStart = new Date(date.getFullYear(), date.getMonth() - 5, 1, 0)
        resEnd = new Date(date.getFullYear(), date.getMonth() + 1, 1)
    } else if (interval === 2) {
        const monthDays = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
        resStart = new Date(date.getFullYear(), date.getMonth(), 1, 0)
        resEnd = new Date(date.getFullYear(), date.getMonth(), monthDays, 23, 59, 59)
    } else if (interval === 3) {
        resStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 6, 0)
        resEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
    } else {
        resStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
        resEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
    }
    return [resStart, resEnd]
}